import Vue from 'vue';
import Vuex from 'vuex';

import { env } from 'app/common/config';

Vue.use(Vuex);

global.Ridi = global.Ridi || {};

export default new Vuex.Store({
  strict: !env.production,
  state: {
    auth: global.Ridi.Auth,
    platform: global.Ridi.Platform,
    globals: global.Ridi.globals || {},
  },
});



// WEBPACK FOOTER //
// ./common/store.js